import React, { useState, useMemo } from "react";
import { Heart, Search, ChevronDown, SlidersHorizontal, Bed, Bath, Ruler, MapPin, ArrowUpDown } from "lucide-react";
import { MapContainer, TileLayer } from "react-leaflet";

const PROPERTIES = [
  {
    id: 1,
    price: 190000,
    beds: 1,
    baths: 1,
    sqft: 261,
    status: "Active",
    tag: "Large deck",
    address: "17369 Pirate Cir",
    city: "Gulf Shores, AL 36542",
    img: "https://picsum.photos/seed/gulf1/600/420",
    type: "Single Family",
  },
  {
    id: 2,
    price: 199000,
    beds: 0,
    baths: 0,
    sqft: null,
    status: "For sale",
    tag: "Price cut $38,000",
    address: "0 Pine Acres Rd",
    city: "Gulf Shores, AL 36542",
    img: "https://picsum.photos/seed/gulf2/600/420",
    type: "Land",
  },
  {
    id: 3,
    price: 289000,
    beds: 2,
    baths: 2,
    sqft: 1120,
    status: "Active",
    tag: "Showcase",
    address: "455 Beach Club Trl",
    city: "Gulf Shores, AL 36542",
    img: "https://picsum.photos/seed/gulf3/600/420",
    type: "Condo",
  },
  {
    id: 4,
    price: 479000,
    beds: 4,
    baths: 3,
    sqft: 2380,
    status: "Active",
    tag: "Above-ground pool",
    address: "112 Dogwood Ct",
    city: "Gulf Shores, AL 36542",
    img: "https://picsum.photos/seed/gulf4/600/420",
    type: "Single Family",
  },
  {
    id: 5,
    price: 655000,
    beds: 3,
    baths: 2,
    sqft: 1890,
    status: "New",
    tag: "New",
    address: "4290 Bay Rd",
    city: "Bon Secour, AL 36511",
    img: "https://picsum.photos/seed/gulf5/600/420",
    type: "Single Family",
  },
  {
    id: 6,
    price: 320000,
    beds: 3,
    baths: 2,
    sqft: 1560,
    status: "Active",
    tag: null,
    address: "1187 Magnolia Ln",
    city: "Foley, AL 36535",
    img: "https://picsum.photos/seed/gulf6/600/420",
    type: "Single Family",
  },
  {
    id: 7,
    price: 4250000,
    beds: 6,
    baths: 5,
    sqft: 5200,
    status: "Active",
    tag: "Waterfront",
    address: "1 Fort Morgan Rd",
    city: "Fort Morgan, AL 36542",
    img: "https://picsum.photos/seed/gulf7/600/420",
    type: "Single Family",
  },
  {
    id: 8,
    price: 590000,
    beds: 3,
    baths: 3,
    sqft: 2010,
    status: "Active",
    tag: null,
    address: "22984 Perdido Beach Blvd",
    city: "Orange Beach, AL 36561",
    img: "https://picsum.photos/seed/gulf8/600/420",
    type: "Condo",
  },
  {
    id: 9,
    price: 305000,
    beds: 2,
    baths: 2,
    sqft: 1340,
    status: "Active",
    tag: "Open house Sat",
    address: "780 Bon Secour Bay Dr",
    city: "Bon Secour, AL 36511",
    img: "https://picsum.photos/seed/gulf9/600/420",
    type: "Townhouse",
  },
];

const money = (n) => "$" + n.toLocaleString("en-US");

function FilterPill({ label, active }) {
  return (
    <button
      className={`
        flex items-center gap-1.5 px-4 py-2 rounded-full border 
        font-semibold text-sm whitespace-nowrap cursor-pointer
        ${active ? "border-sky-500 bg-sky-50 text-sky-700" : "border-gray-300 bg-white text-gray-700"}
      `}
    >
      {label}
      <ChevronDown size={14} strokeWidth={2.5} />
    </button>
  );
}

function PropertyCard({ p, saved, onToggleSave }) {
  return (
    <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm flex flex-col">
      {/* <div className="relative aspect-[4/2.7] bg-sky-100">
        <img src={p.img} alt={p.address} className="w-full h-full object-cover block" />
        {p.tag && <span className="absolute top-2.5 left-2.5 bg-[#0B3556] text-white text-xs font-bold px-2 py-1 rounded-md">{p.tag}</span>}
        <button onClick={() => onToggleSave(p.id)} aria-label="Save property" className="absolute top-2.5 right-2.5 w-8 h-8 rounded-full border-none bg-blue-900/50 flex items-center justify-center cursor-pointer">
          <Heart size={16} color="#fff" fill={saved ? "#FF6B6B" : "none"} strokeWidth={2} />
        </button>
      </div> */}

      <div className="text-left px-3.5 py-3">
        <div className="text-sm text-gray-700 leading-snug">
          <div className="font-semibold">{p.address}</div>
          <div className="text-gray-500">{p.city}</div>
        </div>
        <div className="text-xl font-extrabold text-[#0B2436] mb-1">{money(p.price)}</div>
        <div className="flex gap-3 text-sm text-gray-600 mb-2 flex-wrap items-end">
          {p.beds > 0 && (
            <span className="flex items-center gap-1">
              <Bed size={14} /> {p.beds} bd
            </span>
          )}
          {p.baths > 0 && (
            <span className="flex items-center gap-1">
              <Bath size={14} /> {p.baths} ba
            </span>
          )}
          {p.sqft && (
            <span className="flex items-center gap-1">
              <Ruler size={14} /> {p.sqft.toLocaleString()} sqft
            </span>
          )}
          <span className="text-gray-400">{p.type}</span>
        </div>
      </div>
    </div>
  );
}

export default function AddressOwnerGroupsV2() {
  const [search, setSearch] = useState("Gulf Shores AL 36542");
  const [sort, setSort] = useState("recommended");
  const [saved, setSaved] = useState({});
  const [showRightPanel, setShowRightPanel] = useState(false);

  const toggleSave = (id) => setSaved((s) => ({ ...s, [id]: !s[id] }));

  const sorted = useMemo(() => {
    const list = [...PROPERTIES];
    if (sort === "price_low") list.sort((a, b) => a.price - b.price);
    if (sort === "price_high") list.sort((a, b) => b.price - a.price);
    if (sort === "newest") list.sort((a, b) => (a.status === "New" ? -1 : 1));
    return list;
  }, [sort]);

  return (
    <>
      <div className="w-screen h-screen bg-gray-100 p-4">
        <div className="flex flex-col h-full gap-4">
          {/* Header */}
          <div className="bg-white border-b border-gray-200 px-5 py-3.5">
            <div className="flex gap-2.5 flex-wrap items-center max-w-7xl mx-auto">
              <div className="flex items-center gap-2 flex-1 min-w-[260px] border border-gray-300 rounded-lg px-3 py-2 bg-white">
                <Search size={16} className="text-gray-400" />
                <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Enter an address, city, zip" className="border-none outline-none bg-transparent text-sm w-full text-[#0B2436]" />
              </div>

              <FilterPill label="For sale" active />
              <FilterPill label="Price" />
              <FilterPill label="Beds & baths" />
              <FilterPill label="Property type" />

              <button className="flex items-center gap-1.5 px-4 py-2 rounded-full border border-gray-300 bg-white text-gray-700 text-sm font-semibold cursor-pointer">
                <SlidersHorizontal size={14} /> More filters
              </button>

              <div className="ml-auto flex items-center gap-2">
                <ArrowUpDown size={14} className="text-gray-400" />
                <select value={sort} onChange={(e) => setSort(e.target.value)} className="border border-gray-300 rounded-md px-2.5 py-2 text-sm font-semibold text-gray-700 bg-white cursor-pointer">
                  <option value="recommended">Homes for you</option>
                  <option value="price_low">Price: low to high</option>
                  <option value="price_high">Price: high to low</option>
                  <option value="newest">Newest</option>
                </select>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4 overflow-hidden flex-1 min-h-0">
            {/* Left */}
            <div
              className={`
      rounded-lg shadow overflow-hidden col-span-7 h-full
      ${showRightPanel ? "hidden md:block" : "block"}
    `}
            >
              <MapContainer center={[40.7128, -74.006]} zoom={8} className="w-full h-full">
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" />
                {/* <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" attribution="Tiles &copy; Esri" /> */}
                {/* <TileLayer url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png" attribution="&copy; OpenTopoMap" /> */}
              </MapContainer>
            </div>

            {/* Right */}
            <div
              className={`
      bg-white rounded-lg shadow overflow-y-auto col-span-5
      w-full relative
      ${showRightPanel ? "block" : "hidden md:block"}
    `}
            >
              <div className="flex items-baseline justify-between mb-3.5 sticky top-0 bg-white p-4 rounded-lg z-[1]">
                <h2 className="text-lg font-extrabold text-[#0B2436] m-0">
                  {sorted.length} homes near {search || "your search"}
                </h2>
              </div>
              <div className="grid sm:grid-cols-2 gap-4 mx-4 mb-4">
                {sorted.map((p) => (
                  <PropertyCard key={p.id} p={p} saved={!!saved[p.id]} onToggleSave={toggleSave} />
                ))}
              </div>
            </div>
          </div>

          <button
            onClick={() => setShowRightPanel((prev) => !prev)}
            className="
    md:hidden
    fixed bottom-6 left-1/2 -translate-x-1/2
    bg-blue-600 text-white
    px-5 py-3 rounded-full shadow-lg
    active:scale-95 transition z-[9999]
  "
          >
            {showRightPanel ? "Show Left" : "Show Right"}
          </button>
        </div>
      </div>
    </>
  );
}
